import React from 'react'
import client1 from "../../assets/ic1.png"
import client2 from "../../assets/ic3.png"
import client3 from "../../assets/ic2.png"
import client4 from "../../assets/ic4.png"


import case1 from "../../assets/case1.jpg"
import case2 from "../../assets/case2.jpg"
import case3 from "../../assets/case3.jpeg"
import case4 from "../../assets/case4.png"
import case5 from "../../assets/case5.jpg"
import case6 from "../../assets/case6.png"
import case7 from "../../assets/case7.jpg"
import case8 from "../../assets/case8.png"
import case9 from "../../assets/case9.jpg"


import { Link } from 'react-router-dom'
import { FaArrowTrendUp } from 'react-icons/fa6'

const caseStudyData = [
    {
        id: 1,
        img: case1,
        title: 'Sabrina Carpenter',
        subtitle: 'Interactive Membership Cards',
        link: 'https://www.instagram.com/magicalifestyle/reel/DCksRkstFTA/'
    },
    {
        id: 2,
        img: case2,
        title: 'Rosé – Retail Store',
        subtitle: 'Interactive Album Stand',
        link: 'https://www.instagram.com/popfaction/reel/DDXZUDlx_nw/'
    },
    {
        id: 3,
        img: case3,
        title: 'Fondation Louis Vuitton',
        subtitle: 'Interactive Portraits',
        link: 'https://www.youtube.com/watch?v=IYG0znU0_jo&list=TLGGyN_7vJ1nxxswNTA1MjAyNQ',
    },
    {
        id: 4,
        img: case4,
        title: 'Korn',
        subtitle: 'Interactive Tour Laminates',
        link: 'https://www.instagram.com/my.interactive/reel/DBra6hnS42j/',
    },
    {
        id: 5,
        img: case5,
        title: 'OneRepublic',
        subtitle: 'Interactive Vinyl Record',
        link: 'https://www.instagram.com/reel/C9W5pdVMT4S/?igsh=MzRlODBiNWFlZA%3D%3D',
    },
    {
        id: 6,
        img: case6,
        title: 'Cal Lutheran University',
        subtitle: 'Custom Branded Interactive App',
        link: 'https://www.callutheran.edu',
    },
    {
        id: 7,
        img: case7,
        title: 'Tate McRae',
        subtitle: 'Interactive Trading Card Set',
        link: 'https://www.instagram.com/t8mcraetours/reel/C9OgxHRtyVJ/',
    },
    {
        id: 8,
        img: case8,
        title: 'Jagged Edge',
        subtitle: 'Interactive Tour Book',
        link: 'https://www.jaggededgetour.com'
    },
    {
        id: 9,
        img: case9,
        title: 'Wallows',
        subtitle: 'Interactive Retail Posters',
        link: 'https://www.tiktok.com/@theliyahrich/video/7482150789440376094'
    },
]

const CaseStudies = () => {
    return (
        <div className='case-studies py-[50px]'>
            <div className="container mx-auto">
                {/* breadcrumb */}
                <div className="breadcrumb rounded-xl case-studies-bradcrumb relative py-[60px] px-[50px]">
                    <h1 className="text-center text-white text-[40px] lg:text-[60px] font-bold">
                        Case Studies
                    </h1>
                </div>
                {/* breadcrumb */}


                <div className="mt-[50px]">
                    <div className="text-center">
                        <h1 className='text-[40px] font-bold'>
                            What our <span className='besley font-normal italic'>partners</span> are saying
                        </h1>
                    </div>

                    <div className="testimonial relative mt-[50px]">
                        <div className="grid lg:grid-cols-2 grid-cols-1 gap-6">
                            <div className="left grid grid-cols-1 gap-6">
                                <div className="card p-5 bg-white shadow-lg rounded-xl">
                                    <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.45 14.1C3.21667 14.1 2.21667 13.6667 1.45 12.8C0.716667 11.9 0.35 10.7333 0.35 9.3C0.35 7.43333 0.9 5.7 2 4.1C3.1 2.46667 4.46667 1.25 6.1 0.45L6.4 1.05C5.7 1.58333 5.08333 2.26667 4.55 3.1C4.01667 3.93333 3.63333 4.96666 3.4 6.2L4.45 6.45C5.61667 6.71667 6.51667 7.21666 7.15 7.95C7.81667 8.65 8.15 9.5 8.15 10.5C8.15 11.5667 7.78333 12.4333 7.05 13.1C6.35 13.7667 5.48333 14.1 4.45 14.1ZM15 14.1C13.7667 14.1 12.7667 13.6667 12 12.8C11.2667 11.9 10.9 10.7333 10.9 9.3C10.9 7.43333 11.45 5.7 12.55 4.1C13.65 2.46667 15.0167 1.25 16.65 0.45L16.95 1.05C16.25 1.58333 15.6333 2.26667 15.1 3.1C14.5667 3.93333 14.1833 4.96666 13.95 6.2L15 6.45C16.1667 6.71667 17.0667 7.21666 17.7 7.95C18.3667 8.65 18.7 9.5 18.7 10.5C18.7 11.5667 18.3333 12.4333 17.6 13.1C16.9 13.7667 16.0333 14.1 15 14.1Z" fill="black"></path>
                                    </svg>

                                    <p className="mt-4 text-lg">
                                    The Live Nation Asia team spanning over 9 countries is excited about our partnership with Interactive! This technology has added a great value to our ticket offerings and fans love connecting their video memories into their merch items. We look forward to continued development in upcoming tours.
                                    </p>

                                    <div className="flex mt-6 justify-between items-center gap-2">
                                        <p className="font-bold">
                                            - Nora Wong, VP Marketing Live Nation Asia
                                        </p>
                                        <img src={client1} alt="" className="w-[80px]" />
                                    </div>
                                </div>
                                <div className="card p-5 bg-white shadow-lg rounded-xl">
                                    <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.45 14.1C3.21667 14.1 2.21667 13.6667 1.45 12.8C0.716667 11.9 0.35 10.7333 0.35 9.3C0.35 7.43333 0.9 5.7 2 4.1C3.1 2.46667 4.46667 1.25 6.1 0.45L6.4 1.05C5.7 1.58333 5.08333 2.26667 4.55 3.1C4.01667 3.93333 3.63333 4.96666 3.4 6.2L4.45 6.45C5.61667 6.71667 6.51667 7.21666 7.15 7.95C7.81667 8.65 8.15 9.5 8.15 10.5C8.15 11.5667 7.78333 12.4333 7.05 13.1C6.35 13.7667 5.48333 14.1 4.45 14.1ZM15 14.1C13.7667 14.1 12.7667 13.6667 12 12.8C11.2667 11.9 10.9 10.7333 10.9 9.3C10.9 7.43333 11.45 5.7 12.55 4.1C13.65 2.46667 15.0167 1.25 16.65 0.45L16.95 1.05C16.25 1.58333 15.6333 2.26667 15.1 3.1C14.5667 3.93333 14.1833 4.96666 13.95 6.2L15 6.45C16.1667 6.71667 17.0667 7.21666 17.7 7.95C18.3667 8.65 18.7 9.5 18.7 10.5C18.7 11.5667 18.3333 12.4333 17.6 13.1C16.9 13.7667 16.0333 14.1 15 14.1Z" fill="black"></path>
                                    </svg>

                                    <p className="mt-4 text-lg">
                                    We are excited to continue to enhance the fan experience within our VIP offerings with the help of the interactive team.
                                    </p>

                                    <div className="flex mt-6 justify-between items-center gap-2">
                                        <p className="font-bold">
                                            - Kelly Goulden – SVP VIP Nation -Live Nation Entertainment
                                        </p>
                                        <img src={client2} alt="" className="w-[80px]" />
                                    </div>
                                </div>
                            </div>
                            <div className="right grid grid-cols-1 gap-6">
                                <div className="card p-5 bg-white shadow-lg rounded-xl">
                                    <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.45 14.1C3.21667 14.1 2.21667 13.6667 1.45 12.8C0.716667 11.9 0.35 10.7333 0.35 9.3C0.35 7.43333 0.9 5.7 2 4.1C3.1 2.46667 4.46667 1.25 6.1 0.45L6.4 1.05C5.7 1.58333 5.08333 2.26667 4.55 3.1C4.01667 3.93333 3.63333 4.96666 3.4 6.2L4.45 6.45C5.61667 6.71667 6.51667 7.21666 7.15 7.95C7.81667 8.65 8.15 9.5 8.15 10.5C8.15 11.5667 7.78333 12.4333 7.05 13.1C6.35 13.7667 5.48333 14.1 4.45 14.1ZM15 14.1C13.7667 14.1 12.7667 13.6667 12 12.8C11.2667 11.9 10.9 10.7333 10.9 9.3C10.9 7.43333 11.45 5.7 12.55 4.1C13.65 2.46667 15.0167 1.25 16.65 0.45L16.95 1.05C16.25 1.58333 15.6333 2.26667 15.1 3.1C14.5667 3.93333 14.1833 4.96666 13.95 6.2L15 6.45C16.1667 6.71667 17.0667 7.21666 17.7 7.95C18.3667 8.65 18.7 9.5 18.7 10.5C18.7 11.5667 18.3333 12.4333 17.6 13.1C16.9 13.7667 16.0333 14.1 15 14.1Z" fill="black"></path>
                                    </svg>

                                    <p className="mt-4 text-lg">
                                    Unique ideas like this are what’s exciting to me. It’s great that on our last record we get to use this technology on the product packaging.
                                    </p>

                                    <div className="flex mt-6 justify-between items-center gap-2">
                                        <p className="font-bold">
                                            - Harry Lyons, Thomas Rhett Day to Day Manager
                                        </p>
                                        <img src={client3} alt="" className="w-[80px]" />
                                    </div>
                                </div>
                                <div className="card p-5 h-auto bg-white shadow-lg rounded-xl">
                                    <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.45 14.1C3.21667 14.1 2.21667 13.6667 1.45 12.8C0.716667 11.9 0.35 10.7333 0.35 9.3C0.35 7.43333 0.9 5.7 2 4.1C3.1 2.46667 4.46667 1.25 6.1 0.45L6.4 1.05C5.7 1.58333 5.08333 2.26667 4.55 3.1C4.01667 3.93333 3.63333 4.96666 3.4 6.2L4.45 6.45C5.61667 6.71667 6.51667 7.21666 7.15 7.95C7.81667 8.65 8.15 9.5 8.15 10.5C8.15 11.5667 7.78333 12.4333 7.05 13.1C6.35 13.7667 5.48333 14.1 4.45 14.1ZM15 14.1C13.7667 14.1 12.7667 13.6667 12 12.8C11.2667 11.9 10.9 10.7333 10.9 9.3C10.9 7.43333 11.45 5.7 12.55 4.1C13.65 2.46667 15.0167 1.25 16.65 0.45L16.95 1.05C16.25 1.58333 15.6333 2.26667 15.1 3.1C14.5667 3.93333 14.1833 4.96666 13.95 6.2L15 6.45C16.1667 6.71667 17.0667 7.21666 17.7 7.95C18.3667 8.65 18.7 9.5 18.7 10.5C18.7 11.5667 18.3333 12.4333 17.6 13.1C16.9 13.7667 16.0333 14.1 15 14.1Z" fill="black"></path>
                                    </svg>

                                    <p className="mt-4 text-lg">
                                    Having content only be accessible in the physical items and not online has been intriguing for the Warner Team as a platform for superfans to connect with their favorite artists. It’s been a pleasure to work with the Interactive team on artist campaigns.
                                    </p>

                                    <div className="flex mt-6 justify-between items-center gap-2">
                                        <p className="font-bold">
                                            - Caroline Giegerich, VP Head of Innovation, Warner Music Group
                                        </p>
                                        <img src={client4} alt="" className="w-[80px]" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="mt-[100px]">
                    <div className="text-center">
                        <h1 className='text-[40px] font-bold'>
                            <span className='besley font-normal italic'>Highlights</span> of our recent work
                        </h1>
                    </div>

                    <div className="mt-[50px] grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[5px]">
                        {
                            caseStudyData.map(item => (
                                <div key={item.id} className="card border relative">
                                    <div className="p-4">
                                        <img src={item.img} alt="" className='w-full' />
                                    </div>
                                    <div className="content p-5 shadow-lg">
                                        <h3 className='text-[20px] font-bold'>{item.title}</h3>
                                        <div className="flex justify-between items-start gap-3">
                                            <p className='text-sm'>{item.subtitle}</p>
                                            <Link
                                                target={'_blank'}
                                                to={item.link && item.link.trim() !== '' ? item.link : '/digital-experience'}
                                                className='text-black px-4 py-2 text-sm flex justify-end items-center gap-2 bg-black text-white decoration-none border-0 underline rounded-[6px] font-semibold'>
                                                Watch Video <FaArrowTrendUp />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CaseStudies
